import ymaps from 'ymaps';
import MapTempl from './list-map.pug';

export default {
  delimiters: ['${', '}}'],
  template: MapTempl(),
  props: ['center', 'items', 'lang'],
  data() {
    return {
      maps: null,
      mapInstance: null,
    };
  },
  watch: {
    items() {
      if (this.mapInstance) {
        this.setItems();
      }
    },
  },
  methods: {
    setItems(disableAutoBounds = false) {
      if (this.mapInstance) {
        this.mapInstance.geoObjects.removeAll();
      }
      const { maps } = this;
      if (this.items) {
        this.items.forEach((item) => {
          item.coords.forEach((coord) => {
            const newCoord = coord.split(',');
            const isImage = item.icon.indexOf('/') !== -1;
            let icon = '';
            let commonIcon = null;
            if (isImage) {
              // eslint-disable-next-line prefer-destructuring
              icon = item.icon;
              commonIcon = maps.templateLayoutFactory.createClass(`<div class="map__common-pin"><img src="${icon}" alt="infrastructure icon"/></div>`);
            } else {
              icon = item.icon.replace('.svg', '');
              commonIcon = maps.templateLayoutFactory.createClass(`<div class="map__common-pin"><svg><use xlink:href="sprite.svg#${icon}"></use></svg></div>`);
            }
            this.mapInstance.geoObjects.add(new maps.Placemark(newCoord, {}, {
              iconLayout: commonIcon,
              iconImageHref: `${item.icon}`,
              iconImageSize: [70, 70],
            }));
          });
        });
      }

      if (this.center) {
        const objectIcon = maps.templateLayoutFactory.createClass('<div class="map__main-pin"><svg><use xlink:href="sprite.svg#map-pin"></use></svg></div>');
        this.mapInstance.geoObjects.add(new maps.Placemark(this.center.coords, {}, {
          iconLayout: objectIcon,
          iconImageHref: `${this.center.icon}`,
          iconImageSize: [50, 67],
        }));
      }

      if (this.items && !disableAutoBounds) {
        this.mapInstance.setBounds(this.mapInstance.geoObjects.getBounds(), {
          checkZoomRange: true,
          zoomMargin: 9,
        }).then(() => {
          if (this.mapInstance.getZoom() > 10) {
            this.mapInstance.setZoom(14);
          }
        });
      }
    },
    updateBounds() {
      if (this.mapInstance && this.mapInstance.geoObjects.getLength() > 1) {
        setTimeout(() => {
          this.mapInstance.setBounds(this.mapInstance.geoObjects.getBounds());
        }, 300);
      }
    },
  },
  mounted() {
    ymaps.load(`https://api-maps.yandex.ru/2.1/?lang=${this.lang || 'ru_RU'}`).then((maps) => {
      this.maps = maps;
      this.mapInstance = new maps.Map(this.$refs.map, {
        center: this.center ? this.center.coords : [55.7522200, 37.6155600],
        zoom: this.center ? this.center.zoom : 16,
        controls: ['zoomControl'],
      });
      this.mapInstance.behaviors.disable(['scrollZoom']);
      this.setItems(true);
    });
  },
};



// WEBPACK FOOTER //
// ./new-blocks/map/list/list-map.js